import TemplateView from "../../../TemplateView";

export const SHOW_IN ={
    CHART: "chart",
    TABLE: "table"
}

export default class TableChartButtons extends TemplateView {

    constructor($containerEl, {
        onClick = (showIn) => {}
    }) {
        super($containerEl);
        this.params = {onClick};

        this.state = {
            showIn: null
        }

        this.onStatePropertyChanged('showIn', (showIn) => {
            this.$chartButton.toggleClass("active", showIn ===SHOW_IN.CHART);
            this.$tableButton.toggleClass("active", showIn ===SHOW_IN.TABLE);
        });
    }

    templateHtml() {
        return "<div class='tableChartButtons'>" +
               "    <div class='tableButton typeButton left'/>" +
               "    <div class='chartButton typeButton right'/> " +
               "</div>"
    }

    afterRender() {
        this.$chartButton = this.find('.chartButton');
        this.$tableButton = this.find('.tableButton');
        const onBtnClick = (showIn) => {
            this.setState({showIn});
            this.params.onClick(showIn);
        }
        this.$chartButton.click(() => onBtnClick(SHOW_IN.CHART));
        this.$tableButton.click(() => onBtnClick(SHOW_IN.TABLE));
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/TableChartButtons.js